"use client";

import { FC } from "react";
import SwiperCore from "swiper";
// import "swiper/css";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import { EditorialCard } from "@/types";

import { CardCarouselBottomNavigation } from "../AutogeneratedCarousel/CardCarouselBottomNavigation";
import EditorialInventoryCard from "./EditorialInventoryCard";

SwiperCore.use([Pagination, Navigation]);
const EditorialInventoryCarousel: FC<{ items: EditorialCard[]; id: string }> = ({ items, id }) => {
  return (
    <>
      <Swiper
        navigation={{
          nextEl: `.swiper-button-next-${id}-inventory`,
          prevEl: `.swiper-button-prev-${id}-inventory`,
        }}
        pagination={{ type: "progressbar", el: `.swiper-pagination-carousel-${id}-inventory` }}
        className="editorial-carousel w-full"
        breakpoints={{
          1024: {
            slidesPerView: "auto",
            centeredSlides: false,
            spaceBetween: 24,
          },
        }}
        spaceBetween={10}
        slidesPerView={1.2}
        centeredSlides={true}
        watchSlidesProgress={true}
      >
        {items.map((item, index) => (
          <SwiperSlide className="md:!w-auto" key={`inventory-carousel-${id}-${index}`}>
            <EditorialInventoryCard item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <CardCarouselBottomNavigation carouselId={`${id}-inventory`} customClass={"mt-[40px]"} />
    </>
  );
};
export default EditorialInventoryCarousel;
